import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  openModal,
  closeModal
} from 'actions/modals'
import {
  clearBreakInWarning
} from 'actions/visits'
import { BREAK_IN_WARNING_MESSAGE_MODAL } from 'constants/modals'
import BreakInWarningMessageModal from 'components/BreakInWarningMessageModal'

class BreakInWarningMessageModalContainer extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.messages.length !== this.props.messages.length && this.props.messages.length > 0) {
      this.props.openModal()
    }
  }

  render() {
    const {
      closeModal,
      modalOpened,
      messages,
      clearMessage
    } = this.props


    return (
      <BreakInWarningMessageModal
        show={modalOpened}
        closeModal={closeModal}
        warningMessages={messages}
        clearMessage={clearMessage}
      />
    )
  }
}

function mapStateToProps (state) {
  return {
    modalOpened: state.modal.currentModal === BREAK_IN_WARNING_MESSAGE_MODAL,
    messages: state.visit.breakInWarningMessages || []
  }
}

function mapDispatchToProps (dispatch) {
  return {
    openModal: () => dispatch(openModal(BREAK_IN_WARNING_MESSAGE_MODAL)),
    closeModal: () => dispatch(closeModal(BREAK_IN_WARNING_MESSAGE_MODAL)),
    clearMessage: () => dispatch(clearBreakInWarning())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BreakInWarningMessageModalContainer)
